/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation
} from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query';

import {
  toValue
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  Message,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Logout Session
 */
export const deleteSession = (

 signal?: AbortSignal
) => {


      return axiosClient<Message>(
      {url: `/sessions`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteSessionMutationKey = () => ['deleteSession'] as const;

export const getDeleteSessionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSession>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteSession>>, TError,void, TContext> => {

const mutationKey = getDeleteSessionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSession>>, void> = () => {


          return  deleteSession()
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSessionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSession>>>

    export type DeleteSessionMutationError = ErrorType<void>


    /**
 * @summary Logout Session
 */
export const useDeleteSession = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSession>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteSession>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDeleteSessionMutationOptions(options), queryClient);
    }
    /**
 * @summary Exit Incognito Mode
 */
export const exitIncognitoMode = (

 signal?: AbortSignal
) => {


      return axiosClient<void>(
      {url: `/sessions/incognito`, method: 'DELETE', signal
    },
      );
    }




export const getExitIncognitoModeMutationKey = () => ['exitIncognitoMode'] as const;

export const getExitIncognitoModeMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exitIncognitoMode>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof exitIncognitoMode>>, TError,void, TContext> => {

const mutationKey = getExitIncognitoModeMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof exitIncognitoMode>>, void> = () => {


          return  exitIncognitoMode()
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExitIncognitoModeMutationResult = NonNullable<Awaited<ReturnType<typeof exitIncognitoMode>>>

    export type ExitIncognitoModeMutationError = ErrorType<void>


    /**
 * @summary Exit Incognito Mode
 */
export const useExitIncognitoMode = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exitIncognitoMode>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof exitIncognitoMode>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getExitIncognitoModeMutationOptions(options), queryClient);
    }
    /**
 * @summary enter incognito mode
 */
export const enterIncognito = (
    toolsUserId: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      toolsUserId = toValue(toolsUserId);

      return axiosClient<void>(
      {url: `/sessions/incognito/${toolsUserId}`, method: 'POST', signal
    },
      );
    }




export const getEnterIncognitoMutationKey = () => ['enterIncognito'] as const;

export const getEnterIncognitoMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enterIncognito>>, TError,EnterIncognitoMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof enterIncognito>>, TError,EnterIncognitoMutationVariables, TContext> => {

const mutationKey = getEnterIncognitoMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enterIncognito>>, EnterIncognitoMutationVariables> = (props) => {
          const {toolsUserId} = props ?? {};

          return  enterIncognito(toolsUserId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnterIncognitoMutationResult = NonNullable<Awaited<ReturnType<typeof enterIncognito>>>

    export type EnterIncognitoMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type EnterIncognitoMutationVariables = {toolsUserId: string}

    /**
 * @summary enter incognito mode
 */
export const useEnterIncognito = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enterIncognito>>, TError,EnterIncognitoMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof enterIncognito>>,
        TError,
        EnterIncognitoMutationVariables,
        TContext
      > => {
      return useMutation(getEnterIncognitoMutationOptions(options), queryClient);
    }
